var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-pa-sm full-height product-tag-list"},[_c('rs-classify',{attrs:{"namespace":"pdtTag"}},[_c('rs-field',{attrs:{"name":"id"}}),_c('rs-field',{attrs:{"name":"name"}}),_c('rs-field',{attrs:{"name":"type.name"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }